import React from 'react';
import './App.css';
import './responsive.css';
import 'bootstrap/dist/css/bootstrap.css';
import RoutePage from './Routes/Routes';
import '../node_modules/swiper/swiper.css'
// import '../node_modules/swiper/components/pagination/pagination.scss'
// import '../node_modules/swiper/components/navigation/navigation.scss'
function App() {
  return (
    <div className="App">
      <RoutePage/>
    </div>
  );
}

export default App;
